import { Injectable, inject } from "@angular/core";
import { DataService } from "@core/services/data.service";
import { Observable } from "rxjs";
import { IUserCourse } from "../interfaces/iuser-course";
import { IUserCourseHistoryByYear } from "../interfaces/iuser-course-history-by-year";

@Injectable({
  providedIn: 'root'
})
export class UserCourseService {
  dataService = inject(DataService);

 getCourseHistory(): Observable<IUserCourseHistoryByYear[]> {
  return this.dataService.get("userCourse/course-history");
  }

  markCourseAsStarted(courseId: number): Observable<IUserCourse> {
    return this.dataService.post(`userCourse/mark-course-as-started/${courseId}`, {});
  }
}
